import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { projekte } from "@/data/projekte";
import { T } from "@/components/T";

export function ProjekteSection() {
  const stripRef = useRef(null);
  const dragState = useRef({ active: false, x: 0, scroll: 0 });
  const wasDragging = useRef(false);

  const handleDragStart = (e) => { wasDragging.current = false; dragState.current = { active: true, x: e.pageX, scroll: stripRef.current.scrollLeft }; };
  const handleDragEnd = () => { dragState.current.active = false; };
  const handleDragMove = (e) => {
    if (!dragState.current.active) return;
    const dx = e.pageX - dragState.current.x;
    if (Math.abs(dx) > 4) wasDragging.current = true;
    stripRef.current.scrollLeft = dragState.current.scroll - dx;
  };

  return (
    <section data-testid="projekte-section" className="section-gap overflow-hidden" style={{ background: "#0b0c0e" }}>
      <div className="container-hb mb-10 flex items-end justify-between">
        <div>
          <span className="label-text block mb-3 reveal" style={{ color: "rgba(245,200,0,0.6)" }}>
            <T de="Referenzen" it="Riferimenti" />
          </span>
          <h2 className="font-bebas text-white reveal reveal-delay-1" style={{ fontSize: "clamp(48px, 6.5vw, 88px)", lineHeight: 1 }}>
            <T de="Projekte." it="Progetti." />
          </h2>
        </div>
        <Link to="/projekte" data-testid="all-projekte-link"
          className="text-[10px] tracking-widest uppercase font-inter flex items-center gap-2 transition-colors reveal"
          style={{ color: "rgba(255,255,255,0.3)" }}
          onMouseEnter={e => e.currentTarget.style.color = "#f5c800"}
          onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.3)"}>
          <T de="Alle ansehen" it="Vedi tutti" /> <ArrowRight size={11} />
        </Link>
      </div>
      <div ref={stripRef} className="projects-strip gap-3 pb-2"
        style={{ paddingLeft: "max(1.5rem, 4vw)", paddingRight: "max(1.5rem, 4vw)" }}
        onMouseDown={handleDragStart} onMouseUp={handleDragEnd} onMouseLeave={handleDragEnd} onMouseMove={handleDragMove}>
        {projekte.slice(0, 8).map((p, i) => (
          <Link key={p.id} to={`/projekte/${p.id}`} data-testid={`projekt-card-${p.id}`}
            className="projects-strip-item group relative overflow-hidden"
            style={{ width: "clamp(280px, 32vw, 400px)", height: "clamp(360px, 42vw, 500px)", flexShrink: 0 }}
            onClick={(e) => { if (wasDragging.current) e.preventDefault(); }}>
            <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" draggable={false} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="text-[9px] tracking-widest uppercase font-semibold block mb-1 font-inter text-hb-yellow">{p.kategorie}</span>
              <h3 className="font-bebas text-white leading-tight" style={{ fontSize: "clamp(22px, 2.5vw, 28px)" }}>{p.title}</h3>
              <p className="text-xs text-white/45 font-inter mt-1">{p.ort} · {p.jahr}</p>
            </div>
            <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="w-8 h-8 flex items-center justify-center" style={{ background: "rgba(245,200,0,0.15)", backdropFilter: "blur(4px)" }}>
                <ArrowUpRight size={14} className="text-hb-yellow" />
              </div>
            </div>
            <div className="absolute top-4 left-4">
              <span className="font-cormorant font-light text-white/15 text-2xl leading-none">{String(i + 1).padStart(2, "0")}</span>
            </div>
          </Link>
        ))}
      </div>
      <div className="container-hb mt-5">
        <p className="text-[9px] tracking-widest font-inter uppercase" style={{ color: "rgba(255,255,255,0.18)" }}>
          <T de="← Ziehen zum Blättern →" it="← Trascina per scorrere →" />
        </p>
      </div>
    </section>
  );
}
